import { useAccessContext } from "@contexts/access/hooks";
import { TokenHandlers } from "@services";

export const useTokenHandlers: () => TokenHandlers = () => useAccessContext();
